import { isInBrowser } from 'utils/is';

if (import.meta.env.VITE_ENV === 'production' && isInBrowser) {
  const $scirpt = document.createElement('script');
  $scirpt.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16570099353';
  $scirpt.async = true;
  document.head.appendChild($scirpt);

  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  function gtag() {
    // @ts-ignore
    dataLayer.push(arguments);
  }
  // @ts-ignore
  gtag('js', new Date());
  // @ts-ignore
  gtag('config', 'AW-16570099353');
}
